import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface MyProfile {
  id: number;
  username: string;
  firstName: string | null;
  lastName: string | null;
  phoneNumber: string | null;
  userGroupName: string | null;
  paymentOfficeName: string | null;
  lastLoginDate: string | null;
}

export interface UpdateMyProfile {
  firstName: string;
  lastName: string;
  phoneNumber: string;
}

/**
 * The signed-in user's own record. /user/me resolves identity from the token — there is no
 * id in these URLs, so one user can never address another's record.
 */
@Injectable({ providedIn: 'root' })
export class ProfileService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/user/me`;

  me(): Observable<MyProfile> { return this.http.get<MyProfile>(this.baseUrl); }

  update(body: UpdateMyProfile): Observable<MyProfile> {
    return this.http.put<MyProfile>(this.baseUrl, body);
  }
}
